import {call, put, takeLatest} from 'redux-saga/effects';
import {
  // get hospital poc list
  getHospitalPocListRequest,
  getHospitalPocListSuccess,
  getHospitalPocListFailure,

  // update hospital poc status
  updateHospitalPocStatusRequest,
  updateHospitalPocStatusSuccess,
  updateHospitalPocStatusFailure,

  // add hospital poc
  addHospitalPocRequest,
  addHospitalPocSuccess,
  addHospitalPocFailure,

  // get hospital profile
  getHospitalProfileRequest,
  getHospitalProfileSuccess,
  getHospitalProfileFailure,

  // update hospital profile
  updateHospitalProfileFailure,
  updateHospitalProfileRequest,
  updateHospitalProfileSuccess,

  // get hospital specialists
  getHospitalSpecialistsRequest,
  getHospitalSpecialistsSuccess,
  getHospitalSpecialistsFailure,

  // invite hospital specialist
  inviteHospitalSpecialistRequest,
  inviteHospitalSpecialistSuccess,
  inviteHospitalSpecialistFailure,

  // edit hospital specialist
  editHospitalSpecialistRequest,
  editHospitalSpecialistSuccess,
  editHospitalSpecialistFailure,

  // get hospital consultation case list
  getHospitalConsultationCaseListRequest,
  getHospitalConsultationCaseListSuccess,
  getHospitalConsultationCaseListFailure,

  // assign hospital specialist to consultation case
  assignHospitalSpecialistToConsultationRequest,
  assignHospitalSpecialistToConsultationSuccess,
  assignHospitalSpecialistToConsultationFailure,

  // get hospital specialist all list
  getHospitalSpecialistAllRequest,
  getHospitalSpecialistAllSuccess,
  getHospitalSpecialistAllFailure,

  // submit hospital help request
  submitHospitalHelpRequestRequest,
  submitHospitalHelpRequestSuccess,
  submitHospitalHelpRequestFailure,
} from '../slices/hospitalAdminSlice';
import {
  getHospitalLevelAdminList,
  updateHospitalPocStatus,
  addHospitalPoc,
  getHospitalProfile,
  updateHospitalProfile,
  getHospitalSpecialists,
  inviteHospitalSpecialist,
  editHospitalSpecialist,
  getHospitalConsultationCaseList,
  assignHospitalSpecialistToConsultation,
  getHospitalSpecialistAll,
  submitHospitalHelpRequest,
} from '@/services/api';
import {SUCCESS_KEY} from '@/constants';

function* getHospitalPocListSaga(action: any): Generator {
  try {
    const response: any = yield call(getHospitalLevelAdminList, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getHospitalPocListSuccess(response.data));
    } else {
      yield put(getHospitalPocListFailure(response.data));
    }
  } catch (error: any) {
    yield put(getHospitalPocListFailure(error.response));
  }
}

function* updateHospitalPocStatusSaga(action: any): Generator {
  try {
    const response: any = yield call(updateHospitalPocStatus, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(updateHospitalPocStatusSuccess(response.data));
    } else {
      yield put(updateHospitalPocStatusFailure(response.data));
    }
  } catch (error: any) {
    yield put(updateHospitalPocStatusFailure(error.response));
  }
}

function* addHospitalPocSaga(action: any): Generator {
  try {
    const response: any = yield call(addHospitalPoc, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(addHospitalPocSuccess(response.data));
    } else {
      yield put(addHospitalPocFailure(response.data));
    }
  } catch (error: any) {
    yield put(addHospitalPocFailure(error.response));
  }
}

function* getHospitalProfileSaga(): Generator {
  try {
    const response: any = yield call(getHospitalProfile);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getHospitalProfileSuccess(response.data));
    } else {
      yield put(getHospitalProfileFailure(response.data));
    }
  } catch (error: any) {
    yield put(getHospitalProfileFailure(error.response));
  }
}

function* updateHospitalProfileSaga(action: any): Generator {
  try {
    const response: any = yield call(updateHospitalProfile, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(updateHospitalProfileSuccess(response.data));
    } else {
      yield put(updateHospitalProfileFailure(response.data));
    }
  } catch (error: any) {
    yield put(updateHospitalProfileFailure(error.response));
  }
}

function* getHospitalSpecialistsSaga(action: any): Generator {
  try {
    const response: any = yield call(getHospitalSpecialists, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getHospitalSpecialistsSuccess(response.data));
    } else {
      yield put(getHospitalSpecialistsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getHospitalSpecialistsFailure(error.response));
  }
}

function* inviteHospitalSpecialistSaga(action: any): Generator {
  try {
    const response: any = yield call(inviteHospitalSpecialist, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(inviteHospitalSpecialistSuccess(response.data));
    } else {
      yield put(inviteHospitalSpecialistFailure(response.data));
    }
  } catch (error: any) {
    yield put(inviteHospitalSpecialistFailure(error.response));
  }
}

function* editHospitalSpecialistSaga(action: any): Generator {
  try {
    const response: any = yield call(editHospitalSpecialist, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(editHospitalSpecialistSuccess(response.data));
    } else {
      yield put(editHospitalSpecialistFailure(response.data));
    }
  } catch (error: any) {
    yield put(editHospitalSpecialistFailure(error.response));
  }
}

function* getHospitalConsultationCaseListSaga(action: any): Generator {
  try {
    const response: any = yield call(getHospitalConsultationCaseList, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getHospitalConsultationCaseListSuccess(response.data));
    } else {
      yield put(getHospitalConsultationCaseListFailure(response.data));
    }
  } catch (error: any) {
    yield put(getHospitalConsultationCaseListFailure(error.response));
  }
}

function* assignHospitalSpecialistToConsultationSaga(action: any): Generator {
  try {
    const response: any = yield call(assignHospitalSpecialistToConsultation, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(assignHospitalSpecialistToConsultationSuccess(response.data));
    } else {
      yield put(assignHospitalSpecialistToConsultationFailure(response.data));
    }
  } catch (error: any) {
    yield put(assignHospitalSpecialistToConsultationFailure(error.response));
  }
}

function* getHospitalSpecialistAllSaga(): Generator {
  try {
    const response: any = yield call(getHospitalSpecialistAll);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getHospitalSpecialistAllSuccess(response.data));
    } else {
      yield put(getHospitalSpecialistAllFailure(response.data));
    }
  } catch (error: any) {
    yield put(getHospitalSpecialistAllFailure(error.response));
  }
}

function* submitHospitalHelpRequestSaga(action: any): Generator {
  try {
    const response: any = yield call(submitHospitalHelpRequest, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(submitHospitalHelpRequestSuccess(response.data));
    } else {
      yield put(submitHospitalHelpRequestFailure(response.data));
    }
  } catch (error: any) {
    yield put(submitHospitalHelpRequestFailure(error.response?.data || {status: 'error', status_code: 'E-10001'}));
  }
}

export default function* hospitalAdminSaga(): Generator {
  yield takeLatest(getHospitalPocListRequest.type, getHospitalPocListSaga);
  yield takeLatest(updateHospitalPocStatusRequest.type, updateHospitalPocStatusSaga);
  yield takeLatest(addHospitalPocRequest.type, addHospitalPocSaga);
  yield takeLatest(getHospitalProfileRequest.type, getHospitalProfileSaga);
  yield takeLatest(updateHospitalProfileRequest.type, updateHospitalProfileSaga);
  yield takeLatest(getHospitalSpecialistsRequest.type, getHospitalSpecialistsSaga);
  yield takeLatest(inviteHospitalSpecialistRequest.type, inviteHospitalSpecialistSaga);
  yield takeLatest(editHospitalSpecialistRequest.type, editHospitalSpecialistSaga);
  yield takeLatest(getHospitalConsultationCaseListRequest.type, getHospitalConsultationCaseListSaga);
  yield takeLatest(assignHospitalSpecialistToConsultationRequest.type, assignHospitalSpecialistToConsultationSaga);
  yield takeLatest(getHospitalSpecialistAllRequest.type, getHospitalSpecialistAllSaga);
  yield takeLatest(submitHospitalHelpRequestRequest.type, submitHospitalHelpRequestSaga);
}
